import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom';

export const OrdersTotalSum = ({orders}) => {

    const [isReady, setIsReady] = useState(false);
    useEffect(() => {
        setIsReady(true);
    });

    if (!isReady) {
        return null;
    }

    const totalSum = orders.reduce((total, cur) => cur.totalAmount + total, 0);

    return createPortal(
        <div>
            общая: <b>{totalSum.toLocaleString('fr-FR')}</b>
        </div>,
        document.getElementById('orders-total-sum'),
    );
}
